<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="ProgressTermin"></IndexBase>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] Duplicate Progress Report Termin
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>
                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_REVISION && header.Status != this.$APPROVAL_STATUS.FULL_APPROVAL)"/>
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <FormField :labelName="$t('verification_date')" fieldName="Doc_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="doc_date" v-model="header.Doc_Date" type="text"
                                :placeholder="$t('verification_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Doc_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('verification_date')) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t('doc_no')" fieldName="Doc_No" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Doc_No" v-model="header.Doc_No" required="true" type="text"
                                    :placeholder="$t('doc_no')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            <div class="field grid">
                                <label for="No_Wo" class="col-4">{{ $t('no_wo') }}</label>
                                <div class="col-6 md-6">
                                    <InputText name="Code" v-model="header.No_WO" type="text" :placeholder="$t('no_wo')"
                                        v-if="header"
                                        :disabled="true"/>
                                    <Skeleton v-else-if="!header" />
                                </div>
                            </div>
                            <FormField :labelName="$t('job_desc')" fieldName="Deskripsi_Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <Textarea name="Deskripsi_Pekerjaan" v-model="header.Deskripsi_Pekerjaan" required="true" type="text"
                                    :placeholder="$t('job_desc')" v-if="header" @change="onChange()"
                                    :disabled="true" />
                            </FormField>
                            <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                    :params="{ docDate: (this.header.Doc_Date != null ? this.header.Doc_Date  : null)}" 
                                    :disabled="true"
                                    />
                            </FormField>
                            <FormField :labelName="$t('no_spo')" fieldName="No_SPO" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="No_SPO" v-model="header.No_SPO" required="true" type="text"
                                    :placeholder="$t('no_spo')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            <FormField :labelName="$t('no_spk')" fieldName="No_SPK" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="No_SPK" v-model="header.No_SPK" required="true" type="text"
                                    :placeholder="$t('no_spk')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            <FormField :labelName="$t('budget')" fieldName="Budget" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Budget" v-model="header.Budget" required="true"
                                    :placeholder="$t('budget')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            <FormField :labelName="$t('Total_Previous_Progress')" fieldName="Total_Previous_Progress" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Total_Previous_Progress" v-model="header.Total_Previous_Progress" required="true" type="text"
                                    :placeholder="$t('Total_Previous_Progress')" v-if="header"  :useGrouping="true"
                                    :disabled="true" v-lock-input="true"/>
                            </FormField>
                            <FormField :labelName="$t('Total_Current_Progress')" fieldName="Total_Current_Progress" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Total_Current_Progress" v-model="header.Total_Current_Progress" required="true" type="text"
                                    :placeholder="$t('Total_Current_Progress')" v-if="header"  :useGrouping="true"
                                    :disabled="true" v-lock-input="true"/>
                            </FormField>
                            <FormField :labelName="$t('Total_To_Date_Progress')" fieldName="Total_To_Date_Progress" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Total_To_Date_Progress" v-model="header.Total_To_Date_Progress" required="true" type="text"
                                    :placeholder="$t('Total_To_Date_Progress')" v-if="header"  :useGrouping="true"
                                    :disabled="true" v-lock-input="true"/>
                            </FormField>
                            <FormField :labelName="$t('Progress_To_Charge')" fieldName="Progress_To_Charge" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Progress_To_Charge" v-model="header.Progress_To_Charge" required="true" type="text"
                                    :placeholder="$t('Progress_To_Charge')" v-if="header"  :useGrouping="true" 
                                    :maxFractionDigits="3"
                                    :minFractionDigits="0"
                                    :max="99"
                                    :disabled="mode != this.$FORM_MODE_CREATE && (mode != this.$FORM_MODE_EDIT || !header.canEdit)" />
                                    <small v-if="header && !header.Progress_To_Charge && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Progress_To_Charge')) }}
                                    </small>
                            </FormField>
                        </div>
                        <div class="col-6">
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            <FormField :labelName="$t(labelAppr1)" fieldName="Username_Appr1" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr1">
                                <CustomSelect name="Username_Appr1" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr1" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As1, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.MC, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr1 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr1)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr2)" fieldName="Username_Appr2" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr2">
                                <CustomSelect name="Username_Appr2" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr2" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As2, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.MC, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr2 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr2)) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t(labelAppr3)" fieldName="Username_Appr3" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr3">
                                <CustomSelect name="Username_Appr3" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr3" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion:header.Appr_As3, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.MC, contractorcode : header.Contractor_Code,companycode: header.Company_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr3 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr3)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr4)" fieldName="Username_Appr4" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr4">
                                <CustomSelect name="Username_Appr4" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr4" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As4,  user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.MC, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr4 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr4)) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t(labelAppr5)" fieldName="Username_Appr5" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr5">
                                <CustomSelect name="Username_Appr5" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr5" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As5,  user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.MC, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr5 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr5)) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL  || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| header.Status != this.$APPROVAL_STATUS.FULL_APPROVAL"/>
                                    <small v-if="header &&((!header.Reason && header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>
                        </div>
                        <div class="col-12">
                            <h5 class="mb-2">Scope</h5>
                            <div style="max-height: 400px; overflow: auto;">
                                <DataTable v-if="header" 
                                    :value="header.Scope ? header.Scope : null"
                                    class="p-datatable-sm editable-cells-table"
                                    editMode="cell"
                                    :rowClass="hideRow"
                                    showGridlines
                                    >
                            <ColumnGroup type="header">
                                <Row>
                                    <Column :header="$t('type')" :rowspan="2" style="width: 80px; min-width: 80px; max-width: 80px;" />
                                    <Column :header="$t('no')" :rowspan="2" style="width: 80px; min-width: 80px; max-width: 80px;" />
                                    <Column :header="$t('scope')" :rowspan="2" style="width: 350px; min-width: 350px; max-width: 350px;" />
                                    <Column :header="$t('unit')" :rowspan="2" style="width: 80px; min-width: 80px; max-width: 80px;" />
                                    <Column :header="$t('contract')" :colspan="2" style="width: 200px; min-width: 200px; max-width: 200px;" />
                                    <Column :header="$t('progress_previous')" :colspan="2" style="width: 200px; min-width: 200px; max-width: 200px;" />
                                    <Column :header="$t('progress_current')" :colspan="2" style="width: 200px; min-width: 200px; max-width: 200px;" />
                                    <Column :header="$t('progress_to_date')" :colspan="2" style="width: 200px; min-width: 200px; max-width: 200px;" />
                                    <Column :header="$t('remark')" :rowspan="2" style="width: 150px; min-width: 150px; max-width: 150px;" />
                                </Row>
                                <Row>
                                    <Column :header="$t('Volume')" style="width: 100px; min-width: 100px; max-width: 100px;" />
                                    <Column :header="$t('%')" style="width: 100px; min-width: 100px; max-width: 100px;" />
                                    <Column :header="$t('Volume')" style="width: 100px; min-width: 100px; max-width: 100px;" />
                                    <Column :header="$t('%')" style="width: 100px; min-width: 100px; max-width: 100px;" />
                                    <Column :header="$t('Volume')" style="width: 100px; min-width: 100px; max-width: 100px;" />
                                    <Column :header="$t('%')" style="width: 100px; min-width: 100px; max-width: 100px;" />
                                    <Column :header="$t('Volume')" style="width: 100px; min-width: 100px; max-width: 100px;" />
                                    <Column :header="$t('%')" style="width: 100px; min-width: 100px; max-width: 100px;" />
                                </Row>
                            </ColumnGroup>
                                <Column field="Section_Type" style="width: 80px; min-width: 80px; max-width: 80px;">
                                        <template #body="slotProps">
                                            <InputText
                                            v-model="slotProps.data.Section_Type"
                                            :disabled="true"
                                            />
                                        </template>
                                    </Column>
                                <Column field="No_BoQ" style="width: 80px; min-width: 80px; max-width: 80px;">
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.No_BoQ"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Scope" style="width: 350px; min-width: 350px; max-width: 350px;">
                                    <template #body="slotProps">
                                        <Textarea 
                                        v-model="slotProps.data.Scope"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Unit" style="width: 80px; min-width: 80px; max-width: 80px;">
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.Unit"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Contract_Volume" style="width: 100px; min-width: 100px; max-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Contract_Volume"
                                        :disabled="true"
                                        :maxFractionDigits="6"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Contract_Percentage" style="width: 100px; min-width: 100px; max-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Contract_Percentage"
                                        :disabled="true"
                                        :maxFractionDigits="3"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Progress_Previous_Volume" style="width: 100px; min-width: 100px; max-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Progress_Previous_Volume"
                                        :disabled="true"
                                        :maxFractionDigits="6"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Progress_Previous_Percentage" style="width: 100px; min-width: 100px; max-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Progress_Previous_Percentage"
                                        :disabled="true"
                                        :maxFractionDigits="3"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Progress_Current_Volume" style="width: 100px; min-width: 100px; max-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Progress_Current_Volume"
                                        :disabled="true"
                                        :maxFractionDigits="6"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Progress_Current_Percentage" style="width: 100px; min-width: 100px; max-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Progress_Current_Percentage"
                                        :disabled="true"
                                        :maxFractionDigits="3"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Progress_To_Date_Volume" style="width: 100px; min-width: 100px; max-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Progress_To_Date_Volume"
                                        :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || !header.canEdit || slotProps.data.Section_Type == 'Section'"
                                        @input="onChangeCurrent($event, slotProps.data)" @blur="onChangeCurrent($event, slotProps.data)"
                                        :maxFractionDigits="6"
                                        :minFractionDigits="0"
                                        v-lock-input="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || !header.canEdit"
                                        />
                                    </template>
                                </Column>
                                <Column field="Progress_To_Date_Percentage" style="width: 100px; min-width: 100px; max-width: 100px;">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Progress_To_Date_Percentage"
                                        :disabled="true"
                                        :maxFractionDigits="3"
                                        :minFractionDigits="0"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Remark" style="width: 150px; min-width: 150px; max-width: 150px;">
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.Remark"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                        @change="onCheckboxChange(slotProps.data)"
                                        />
                                    </template>
                                </Column>
                            </DataTable>
                            </div>
                        </div>
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>
<script>
import moment from 'moment';
import IndexBase from '../Helper/IndexBase.vue';
export default {
    name: "Editor",
    components: {
        IndexBase
    },  
    data(){
        return {
            indexName: "ProgressTerminIndex",
            url: this.$API_URL + "ProgressTermin/",
            header: null,
            mode: "",
            type: "",
            typeName: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            dataChangesLog:this.$dataChangesLog3,
            labelAppr1 : "",
            labelAppr2 : "",
            labelAppr3 : "",
            labelAppr4 : "",
            labelAppr5 : "",
            submitted2 : false,
            detailLog : null,
            submitted: false,
            onlyDraft: false,
        }
    },
    // watch removed - not needed with responsiveLayout="scroll"
    methods:{
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },  
        getData() {
            var self = this;
             this.$axios.get(this.url + this.mainid + "/" +this.id + "/" +  false  + "/" + this.mode)
                .then((response) => {
                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }

                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.detailLog = self.header.DetailLog;
                    var listAppr = response.data.data.listPicAppr;
                    if(listAppr.length > 0)
                    {
                        listAppr.forEach(a=>{
                            if(a.Sign_Position == 1){
                                self.labelAppr1 = a.Approval_As;
                                self.header.Appr_As1 = a.Approval_As;
                                self.header.Sign_Position1 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 2){
                                self.labelAppr2 = a.Approval_As;
                                self.header.Appr_As2 = a.Approval_As;
                                self.header.Sign_Position2 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 3){
                                self.labelAppr3 = a.Approval_As;
                                self.header.Appr_As3 = a.Approval_As;
                                self.header.Sign_Position3 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 4){
                                self.labelAppr4 = a.Approval_As;
                                self.header.Appr_As4 = a.Approval_As;
                                self.header.Sign_Position4 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 5){
                                self.labelAppr5 = a.Approval_As;
                                self.header.Appr_As5 = a.Approval_As;
                                self.header.Sign_Position5 =  a.Sign_Position;
                            }
                        });
                    }
                    
                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        confirm(event){
            this.submitted = true;
            var self = this;
            if ((!this.header.Doc_Date ||
                (!this.header.Reason && this.header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL))
                || (this.labelAppr1 && !this.header.Username_Appr1) || (this.labelAppr2 && !this.header.Username_Appr2) || (this.labelAppr3 && !this.header.Username_Appr3) || (this.labelAppr4 && !this.header.Username_Appr4) || (this.labelAppr5 && !this.header.Username_Appr5)) {
                return;
            }
            if(self.mode != this.$FORM_MODE_DELETE)
            {
                if(!this.header.Doc_Date || !this.header.Progress_To_Charge){
                    return;
                }
                if(this.header.Progress_To_Charge > this.header.Total_To_Date_Progress)
                {
                    self.showError("Error", "Cannot Submit, Progress to Charge cannot exceed Progress To Date");
                    return;
                }
                if(this.header.Progress_To_Charge <= this.header.MIN_Progress_To_Charge)
                {
                    self.showError("Error", "Cannot Submit, Progress to Charge cannot be equals and less than (" + this.header.MIN_Progress_To_Charge +"%)" );
                    return;
                }
            }
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
        },
        confirmDraft(event)
        {
            this.submitted = true;
            var self = this;
            if(self.mode != this.$FORM_MODE_DELETE)
            {
                if(!this.header.Doc_Date){
                    return;
                }
                if(this.header.Progress_To_Charge > this.header.Total_To_Date_Progress)
                {
                    self.showError("Error", "Cannot Submit, Progress to Charge cannot exceed Progress To Date");
                    return;
                }
                if(this.header.Progress_To_Charge <= this.header.MIN_Progress_To_Charge)
                {
                    self.showError("Error", "Cannot Submit, Progress to Charge cannot be equals and less than (" + this.header.MIN_Progress_To_Charge +"%)" );
                    return;
                }
            }
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
        },
        saveData(){
            this.$emit('block-ui');
            var self = this;
            if(this.header)
            {
                this.header.Main_Data_Id = this.mainid;
                this.header.Doc_Date_String = moment(this.header.Doc_Date).format("YYYY/MM/DD").toString();
            }
            this.$axios.post(this.url + "savechild", this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: `Progress Report Termin ${this.typeName} has been deleted successfully`, life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: `Progress Report Termin ${this.typeName} has been saved successfully`, life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        onChangeCurrent(e, row)
        {
            const value = typeof e.valueNumber === 'number' ? e.valueNumber : e.value;
            row.Progress_To_Date_Percentage = row.Contract_Volume != 0 ? (value / row.Contract_Volume) * row.Contract_Percentage : 0;
            row.Progress_Current_Volume = (value - row.Progress_Previous_Volume);
            if(value > row.Contract_Volume)
            {
                this.showError("Error", "Cannot Submit, Progress to Date Volume cannot exceed Contract Volume");
            }
            row.Progress_Current_Percentage = row.Contract_Volume != 0 ? (row.Progress_Current_Volume / row.Contract_Volume) * row.Contract_Percentage : 0;
            // if(row.Progress_Current_Volume < 0)
            // {
            //     this.showError("Error", "Cannot Submit, Progress Current is Minus for Scope");
            // }
            if (this.header?.Scope?.length) {
                this.header.Total_Current_Progress = this.header.Scope.reduce(
                    (sum, item) => sum + (Number(item.Progress_Current_Percentage) || 0),
                    0
                );
                this.header.Total_To_Date_Progress = this.header.Scope.reduce(
                    (sum, item) => sum + (Number(item.Progress_To_Date_Percentage) || 0),
                    0
                );
            } else {
                this.header.Total_Current_Progress = 0;
                this.header.Total_To_Date_Progress = 0;
            }
            
            if (row.mode == this.$FORM_MODE_UNCHANGED) {
                row.mode = this.$FORM_MODE_EDIT;
            }
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        if(this.$route.query.mainid != undefined)
            this.mainid = this.$route.query.mainid ?? 0;
        else
            this.mainid = this.$route.query.parentid ?? 0;
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
        this.getData();
    }
}
</script>

<style scoped>
/* Table base styling */
::v-deep(.editable-cells-table) {
   font-size: 1rem;
}

::v-deep(.editable-cells-table .p-inputtext),
::v-deep(.editable-cells-table .p-inputnumber-input),
::v-deep(.editable-cells-table .p-inputtextarea) {
   font-size: 1rem;
   width: 100%;
}

::v-deep(.p-datatable .p-datatable-tbody > tr > td) {
   white-space: normal;
   word-wrap: break-word;
}

/* Textarea height */
::v-deep(.p-datatable .p-datatable-tbody > tr > td textarea) {
   min-height: 60px;
}

/* Row coloring based on mode status */
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created > td) {
   background-color: #c8e6c9 !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-created:hover),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-created:hover > td) {
   background-color: #a5d6a7 !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited > td) {
   background-color: #fff9c4 !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited:hover),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-edited:hover > td) {
   background-color: #fff59d !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted > td) {
   background-color: #ffcdd2 !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted:hover),
::v-deep(.p-datatable .p-datatable-tbody > tr.row-deleted:hover > td) {
   background-color: #ef9a9a !important;
}

::v-deep(.p-datatable .p-datatable-tbody > tr.row-hidden) {
   display: none;
}

/* Center header content */
::v-deep(.p-datatable .p-datatable-thead > tr > th) {
   text-align: center;
}

::v-deep(.p-datatable .p-datatable-thead > tr > th .p-column-header-content) {
   justify-content: center;
}
</style>